"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SystemDetailComponent = _interopRequireDefault(require("../components/SystemDetailComponent"));
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
var _strings = require("../common_features/utility/strings");
var _helper = require("../common_features/utility/helper");
var _systemsReducer = require("../common_features/redux/reducers/systemsReducer");
var _Services = require("../common_features/utility/Services");
var _alertReducer = require("../common_features/redux/reducers/alertReducer");
var _AboutThisSystemModalComponent = _interopRequireDefault(require("../components/AboutThisSystemModalComponent"));
var _underscore = _interopRequireDefault(require("underscore"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SystemDetail = () => {
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const timeOutRef = (0, _react.useRef)(null);
  const [accessoryData, setAccessoryData] = (0, _react.useState)("");
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const {
    selectedStore
  } = (0, _reactRedux.useSelector)(state => state.stores);
  let checkUser = userInfo.userType === 5 || userInfo.userType === 7 ? true : false;
  const {
    selectedSystems
  } = (0, _reactRedux.useSelector)(state => state.systems);
  const [sensorEstablished, setSensorEstablished] = (0, _react.useState)(false);
  const [openErrorModal, setOpenErrorModal] = (0, _react.useState)(false);
  const [warningModal, setWarningModal] = (0, _react.useState)(false);
  const [aboutTextModal, setAboutTextModal] = (0, _react.useState)(false);
  const [systemPartData, setSystemPartData] = (0, _react.useState)([]);
  const [date, setDate] = (0, _react.useState)("");
  const [isPartial, setIsPartial] = (0, _react.useState)(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.isComplete);
  const [totalPage, setTotalPage] = (0, _react.useState)(0);
  const [currentPage, setCurrentPage] = (0, _react.useState)(0);
  const [editWaterInfoFlag, setEditWaterInfoFlag] = (0, _react.useState)(true);
  let waterDest = [];
  const aboutTextModalData = {
    variant: "otp-modal",
    displayModal: aboutTextModal,
    modalHeaderIcon: false,
    displayCrossIcon: false,
    modalDetailText: /*#__PURE__*/_react.default.createElement(_AboutThisSystemModalComponent.default, {
      heading: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemModelNumber,
      content: systemPartData === null || systemPartData === void 0 ? void 0 : systemPartData.short_description
    }),
    positiveActionButtonTitle: "OK",
    positiveAction: () => handleAboutTxtOkBtn()
  };

  /* Line 82 to 108 is to Handle the Delete System Modal Action that Uses Web Socket
     Check the remove System Function */
  const handleAboutTxtOkBtn = () => {
    setAboutTextModal(false);
  };
  const handleDeleteErrorRetry = () => {
    setOpenErrorModal(false);
    (0, _helper.removeSystem)(setIsLoading, selectedSystems.systemId, timeOutRef, setSensorEstablished, navigate, setOpenErrorModal);
  };
  const handleDeleteErrorCancel = () => {
    setOpenErrorModal(false);
  };
  const handleFailureContinue = () => {
    setWarningModal(false);
    (0, _helper.removeSystem)(setIsLoading, selectedSystems.systemId, timeOutRef, setSensorEstablished, navigate, setOpenErrorModal);
  };
  const handlefailureCancel = () => {
    setWarningModal(false);
  };
  const handleRemoveSysBtn = () => {
    setWarningModal(true);
  };
  (0, _react.useImperativeHandle)(timeOutRef, () => ({
    onTimeout: () => {
      if (!sensorEstablished) {
        setOpenErrorModal(true);
        setIsLoading(false);
      }
    }
  }));
  const warningSystemModalData = {
    variant: "warning-modal",
    displayModal: warningModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Warning",
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: "Removing this system will remove all attached accessories. You will not lose any historical data previously collected.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: "#333333",
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Continue",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleFailureContinue(),
    negativeAvtion: () => handlefailureCancel()
  };
  const deleteErrorSystemModalData = {
    variant: "error-modal",
    displayModal: openErrorModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Error",
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: "The requested action did not complete successfully, please try again.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Retry",
    negativeButtonActionTitle: "Cancel",
    positiveAction: () => handleDeleteErrorRetry(),
    negativeAvtion: () => handleDeleteErrorCancel()
  };
  const handleBackToStore = () => {
    navigate(_RoutePath.default.techDispatcher.useLink);
  };
  const handleOnClickEditWater = () => {
    dispatch((0, _systemsReducer.setSelectedWaterDest)({}));
    navigate(_RoutePath.default.editWaterDestination.useLink);
  };
  const handleAboutText = () => {
    fetchSystemDetail(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemPartNumber);
    // setAboutTextModal(true)
  };
  const onClickArrowRight = (accessoryName, selectAccessory, type) => {
    if (accessoryName === "Sensor") {
      dispatch((0, _systemsReducer.accessorySelected)(selectAccessory));
      navigate(_RoutePath.default.EditSensor.useLink);
    } else if (type === "Accessory") {
      dispatch((0, _systemsReducer.accessorySelected)(selectAccessory));
      navigate(_RoutePath.default.editAccessory.useLink);
    } else if (type === "Replacement Part") {
      dispatch((0, _systemsReducer.accessorySelected)(selectAccessory));
      navigate(_RoutePath.default.editFilter.useLink, {
        state: {
          date: selectAccessory.refAppInstallationDate
        }
      });
    }
  };
  const handleOnClickAddAccessory = () => {
    navigate(_RoutePath.default.addAccessory.useLink);
  };
  const fetchSystemDetail = async systemId => {
    setIsLoading(true);
    try {
      const systemData = await (0, _Services.GetAddSystemDetails)(systemId);
      setSystemPartData(systemData);
      setIsLoading(false);
      setAboutTextModal(true);
    } catch (error) {
      setIsLoading(false);
      alert(error);
    }
  };
  const getAccessory = async () => {
    setIsLoading(true);
    try {
      var _data$data, _data$data$data, _data$data2, _data$data2$data, _data$data3, _data$data3$data, _data$data4, _data$data5, _data$data5$data, _data$data7, _data$data7$data;
      const data = await (0, _Services.getSystemDetails)(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemId);
      setDate(data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$data = _data$data.data) === null || _data$data$data === void 0 ? void 0 : _data$data$data.installedDate);
      waterDest = data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : (_data$data2$data = _data$data2.data) === null || _data$data2$data === void 0 ? void 0 : _data$data2$data.waterDest;
      let filters = [];
      let accessory = [];
      data === null || data === void 0 ? void 0 : (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : (_data$data3$data = _data$data3.data) === null || _data$data3$data === void 0 ? void 0 : _data$data3$data.SystemReferenceMappings.forEach(item => {
        if ((item === null || item === void 0 ? void 0 : item.refAppType) !== "Accessory") {
          filters.push(item);
        } else {
          accessory.push(item);
        }
      });
      filters.sort((p1, p2) => p1.refAppLifeStatus < p2.refAppLifeStatus ? 1 : p1.refAppLifeStatus > p2.refAppLifeStatus ? -1 : 0);
      data.data.data.SystemReferenceMappings = [...filters, ...accessory];
      setAccessoryData(data === null || data === void 0 ? void 0 : (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.data);
      dispatch((0, _systemsReducer.setPartialSysLoading)(false));
      if (!(data !== null && data !== void 0 && (_data$data5 = data.data) !== null && _data$data5 !== void 0 && (_data$data5$data = _data$data5.data) !== null && _data$data5$data !== void 0 && _data$data5$data.isComplete) || !("item" in selectedSystems)) {
        var _data$data6, _data$data6$data;
        dispatch((0, _systemsReducer.selectSystems)({
          ...data.data.data
        }));
        setIsPartial(data === null || data === void 0 ? void 0 : (_data$data6 = data.data) === null || _data$data6 === void 0 ? void 0 : (_data$data6$data = _data$data6.data) === null || _data$data6$data === void 0 ? void 0 : _data$data6$data.isComplete);
      }
      return data === null || data === void 0 ? void 0 : (_data$data7 = data.data) === null || _data$data7 === void 0 ? void 0 : (_data$data7$data = _data$data7.data) === null || _data$data7$data === void 0 ? void 0 : _data$data7$data.isComplete;
    } catch (error) {
      setIsLoading(false);
      navigate(_RoutePath.default.techDispatcher.useLink);
    }
  };
  const onClickAlert = data => {
    dispatch((0, _alertReducer.selectedAlertData)(data));
    navigate(_RoutePath.default.StoreAlertsDetails.useLink);
  };
  (0, _react.useEffect)(() => {
    const customCall = async () => {
      setIsLoading(true);
      const systemStatus = await getAccessory();
      if (systemStatus) {
        await updateAlerts();
      }
      setIsLoading(false);
    };
    customCall();
  }, []);
  const updateAlerts = async () => {
    let currSystem = _underscore.default.omit(selectedSystems, "item");
    let alerts = await (0, _Services.getAlerts)(selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.storeId);
    let newData = (0, _helper.manageAlertData)(alerts === null || alerts === void 0 ? void 0 : alerts.data);
    (0, _helper.updateAlertItemArrayInRedux)(newData, currSystem);
    currSystem.waterDest = waterDest;
    dispatch((0, _systemsReducer.selectSystems)({
      ...currSystem
    }));
    return true;
  };
  const searchByPair = arr => {
    return arr.find(o => o.refAppType === "Accessory") || false;
  };
  (0, _react.useEffect)(() => {
    (0, _Services.GetAddSystemDetails)(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.systemPartNumber).then(partData => {
      var _partData$reference_i, _partData$reference_i2, _selectedSystems$Syst, _selectedSystems$Serv, _selectedSystems$Serv2, _selectedSystems$Serv3, _selectedSystems$Serv4, _selectedSystems$Serv5;
      let partStepLength = 0;
      const filterData = _underscore.default.groupBy(partData === null || partData === void 0 ? void 0 : (_partData$reference_i = partData.reference_ids) === null || _partData$reference_i === void 0 ? void 0 : _partData$reference_i.filter(item => (item === null || item === void 0 ? void 0 : item.reference_type) !== "Accessory"), "sequence");
      const accessoryData = partData === null || partData === void 0 ? void 0 : (_partData$reference_i2 = partData.reference_ids) === null || _partData$reference_i2 === void 0 ? void 0 : _partData$reference_i2.filter(item => (item === null || item === void 0 ? void 0 : item.reference_type) === "Accessory");
      selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Syst = selectedSystems.SystemReferenceMappings) === null || _selectedSystems$Syst === void 0 ? void 0 : _selectedSystems$Syst.forEach(list => {
        if (list.refAppType !== "Accessory") {
          partStepLength = partStepLength + 1;
        }
      });
      let page = Object.keys(filterData).length * 2 + 4;
      page = _underscore.default.isEmpty(accessoryData) ? page : page + 2;
      setTotalPage(page);
      const partialSequence = _underscore.default.isEmpty(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.SystemReferenceMappings) ? [0] : _underscore.default.pluck(selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.SystemReferenceMappings, "sequence");
      const partSequenceMax = Math.max(...partialSequence);
      const fullSequence = _underscore.default.isEmpty(partData.reference_ids) ? [0] : _underscore.default.pluck(partData.reference_ids, "sequence");
      const fullSequenceMax = Math.max(...fullSequence);
      if (+partSequenceMax === +fullSequenceMax) {
        if (!searchByPair(selectedSystems.SystemReferenceMappings) && !_underscore.default.isEmpty(accessoryData)) {
          setCurrentPage(partStepLength * 2 + 1 - 1);
        } else {
          setCurrentPage(partStepLength * 2 + (accessoryData !== null && accessoryData !== void 0 && accessoryData.length ? 2 : 0) + 1 - 1);
        }
      }
      if (selectedSystems !== null && selectedSystems !== void 0 && (_selectedSystems$Serv = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv2 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv2 === void 0 ? void 0 : _selectedSystems$Serv2.length) - 1]) !== null && _selectedSystems$Serv !== void 0 && _selectedSystems$Serv.ServiceLogImageUrls[0]) {
        setCurrentPage(partStepLength * 2 + (accessoryData !== null && accessoryData !== void 0 && accessoryData.length ? 2 : 0) + 4 - 1);
      } else if (selectedSystems !== null && selectedSystems !== void 0 && (_selectedSystems$Serv3 = selectedSystems.ServiceLogs[(selectedSystems === null || selectedSystems === void 0 ? void 0 : (_selectedSystems$Serv5 = selectedSystems.ServiceLogs) === null || _selectedSystems$Serv5 === void 0 ? void 0 : _selectedSystems$Serv5.length) - 1]) !== null && _selectedSystems$Serv3 !== void 0 && (_selectedSystems$Serv4 = _selectedSystems$Serv3.ServiceLogReadings[0]) !== null && _selectedSystems$Serv4 !== void 0 && _selectedSystems$Serv4.readings) {
        setCurrentPage(partStepLength * 2 + (accessoryData !== null && accessoryData !== void 0 && accessoryData.length ? 2 : 0) + 3 - 1);
      } else if (selectedSystems !== null && selectedSystems !== void 0 && selectedSystems.waterDest) {
        setCurrentPage(partStepLength * 2 + (accessoryData !== null && accessoryData !== void 0 && accessoryData.length ? 2 : 0) + 2 - 1);
      } else {
        setCurrentPage(partStepLength * 2 + 1 - 1);
      }
    }).catch(e => {
      console.log(e);
    });
  }, [selectedSystems]);
  const handleOnClickSystemArrow = () => {
    dispatch((0, _systemsReducer.setSelectedDate)(new Date(date)));
    navigate(_RoutePath.default.editSystem.useLink, {
      state: {
        date: new Date(date)
      }
    });
  };
  const handleClick = () => {
    dispatch((0, _systemsReducer.setSelectedFilterData)({}));
    navigate(_RoutePath.default.serviceLogs.useLink);
  };
  const handlePartialContinue = () => {
    navigate(_RoutePath.default.addSystem.useLink);
  };
  const handleEditWaterInfo = () => {
    dispatch((0, _systemsReducer.setSelectedDetails)({}));
    navigate(_RoutePath.default.WaterInfo.useLink);
  };
  const editPhotoClicked = () => {
    dispatch((0, _systemsReducer.setSelectedDetails)({}));
    dispatch((0, _systemsReducer.imageData)([]));
    navigate(_RoutePath.default.imageUpload.useLink, {
      state: {
        fromScreen: 'editPhoto'
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_SystemDetailComponent.default, {
    alertData: selectedSystems === null || selectedSystems === void 0 ? void 0 : selectedSystems.item,
    heading: "SYSTEM DASHBOARD",
    subHeading: "ServiceConnect",
    separator: "|",
    leftArrow: _index.default.leftArrow.default,
    backNavigationScreen: "Store Dashboard",
    handleBack: handleBackToStore,
    systemAccessoryDetail: selectedSystems,
    systemDetails: accessoryData === null || accessoryData === void 0 ? void 0 : accessoryData.SystemReferenceMappings,
    systemImage: selectedSystems.systemImageUrl ? selectedSystems.systemImageUrl : _index.default.noImg.default,
    systemName: selectedSystems.systemModelNumber,
    systemPartNumber: selectedSystems.systemPartNumber,
    installedText: "Installed",
    installedDate: (0, _helper.getDate)(date),
    questionIcon: _index.default.questionIcon.default,
    aboutText: "About this system",
    statusText: "Status",
    alertImage: _index.default.everythingOkIcon.default,
    alertText: _strings.storeTileStrings.SUCCESS_LABEL,
    plusIcon: _index.default.plusStoreIcon.default,
    editWaterInfoFlag: editWaterInfoFlag,
    editWaterIcon: _index.default.editWaterIcon.default,
    addImageIcon: _index.default.addImageIcon.default,
    handleOnClickEditWaterInfo: handleEditWaterInfo,
    editWaterText: "Edit Water Destination",
    editPhotoClicked: editPhotoClicked
    // sensorText={"Sensor"}
    ,
    accessoryText: "Accessory",
    completeSystemText: "Complete System",
    handleOnClickEditWater: handleOnClickEditWater,
    waterDestinationItem: _strings.waterDestinationItem,
    part: "Part  #",
    installedDateText: "Installed",
    isArrowImageVisible: checkUser,
    isEditVisible: checkUser,
    editImageRight: _index.default.EditPencil.default,
    editTextRight: "Edit",
    onClickArrowRight: onClickArrowRight,
    filterLifeText: "Filter Life"
    // handleOnClickSensor={handleOnClickSensor}
    ,
    isLoading: isLoading,
    onClickAlert: onClickAlert,
    storeId: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.storeId,
    handleRemoveSysBtn: handleRemoveSysBtn,
    removeSysBtn: false,
    warningSystemModal: warningModal,
    warningSystemModalData: warningModal ? warningSystemModalData : deleteErrorSystemModalData,
    openSystemErrorModal: openErrorModal,
    handleAboutText: handleAboutText,
    aboutTextModalData: aboutTextModalData,
    aboutTextModal: aboutTextModal,
    handleOnClickAddAccessory: handleOnClickAddAccessory,
    onClickSystemArrow: handleOnClickSystemArrow,
    handlePartialContinue: handlePartialContinue,
    isContinueVisible: isPartial,
    partialLogo: _index.default.timerLogo.default,
    currentPage: currentPage,
    totalPage: totalPage,
    pencilIcon: _index.default.EditPencil.default,
    handleClick: handleClick,
    isPartial: isPartial,
    store: "Service History",
    arrowIcon: _index.default.ArrowRight.default
  });
};
var _default = exports.default = SystemDetail;